var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 284 57"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1a1a1a",
  d: "M241.27 1.165h24.776c10.425 0 17.372 6.231 17.372 15.216 0 6.34-2.946 11.914-9.892 13.803v.224c4.65 1.19 8.228 4.36 8.228 10.125 0 6.024-.267 8.728 2.221 14.393l-.075.233h-9.983c-1.664-3.111-2.28-6.214-2.28-12.404 0-5.341-2.862-8.32-8.32-8.32h-11.065V55.16H241.27zm10.982 24.792H263.9c5.965 0 8.91-3.835 8.91-8.145s-2.812-7.828-8.627-7.828h-11.931z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__a)",
  d: "M241.27 1.165h24.776c10.425 0 17.372 6.231 17.372 15.216 0 6.34-2.946 11.914-9.892 13.803v.224c4.65 1.19 8.228 4.36 8.228 10.125 0 6.024-.267 8.728 2.221 14.393l-.075.233h-9.983c-1.664-3.111-2.28-6.214-2.28-12.404 0-5.341-2.862-8.32-8.32-8.32h-11.065V55.16H241.27zm10.982 24.792H263.9c5.965 0 8.91-3.835 8.91-8.145s-2.812-7.828-8.627-7.828h-11.931z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1a1a1a",
  d: "m91.4 55.16-24.002-36L55.4 1.165H43.395L61.4 28.162 43.395 55.16h12.006l11.997-17.995L79.394 55.16z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__b)",
  d: "m91.4 55.16-24.002-36L55.4 1.165H43.395L61.4 28.162 43.395 55.16h12.006l11.997-17.995L79.394 55.16z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#1a1a1a",
  d: "M67.39 19.135h5.94a11.33 11.33 0 0 0 9.434-4.992L91.4 1.165h-5.94a11.33 11.33 0 0 0-9.427 5.042z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__c)",
  d: "M67.39 19.135h5.94a11.33 11.33 0 0 0 9.434-4.992L91.4 1.165h-5.94a11.33 11.33 0 0 0-9.427 5.042z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#1a1a1a",
  d: "M179.78 47.805h-.15c-3.702 6.198-8.761 8.386-15.184 8.386-8.153 0-14.501-2.945-18.952-7.854-4.451-4.908-7.03-11.939-7.03-20.05 0-8.985 3.178-16.84 8.836-22.056C151.684 2.188 157.425 0 164.671 0c13.594 0 21.373 7.488 23.112 18.054h-10.724c-1.206-5.217-5.208-8.994-12.155-8.994-10.158 0-15.258 8.461-15.258 19.227 0 11.023 5.824 19.135 15.1 19.135 8.627 0 13.902-6.78 13.902-12.746v-.2h-12.995v-8.519h22.737v29.12h-8.236z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__d)",
  d: "M179.78 47.805h-.15c-3.702 6.198-8.761 8.386-15.184 8.386-8.153 0-14.501-2.945-18.952-7.854-4.451-4.908-7.03-11.939-7.03-20.05 0-8.985 3.178-16.84 8.836-22.056C151.684 2.188 157.425 0 164.671 0c13.594 0 21.373 7.488 23.112 18.054h-10.724c-1.206-5.217-5.208-8.994-12.155-8.994-10.158 0-15.258 8.461-15.258 19.227 0 11.023 5.824 19.135 15.1 19.135 8.627 0 13.902-6.78 13.902-12.746v-.2h-12.995v-8.519h22.737v29.12h-8.236z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#1a1a1a",
  d: "M195.57 1.165h39.727v9.21h-28.778v13.311h25.225v9.01h-25.225v13.312h28.778v9.151H195.57z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__e)",
  d: "M195.57 1.165h39.727v9.21h-28.778v13.311h25.225v9.01h-25.225v13.312h28.778v9.151H195.57z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#1a1a1a",
  d: "M95.069 1.165h39.71v9.21h-28.762v13.311h25.226v9.01h-25.226v13.312h28.762v9.151h-39.71z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__f)",
  d: "M95.069 1.165h39.71v9.21h-28.762v13.311h25.226v9.01h-25.226v13.312h28.762v9.151h-39.71z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#1a1a1a",
  d: "M0 1.165h39.726v9.21H10.95v13.311h25.225v9.01H10.949v13.312h28.777v9.151H0z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__g)",
  d: "M0 1.165h39.726v9.21H10.95v13.311h25.225v9.01H10.949v13.312h28.777v9.151H0z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__a",
  x1: 262.623,
  x2: 262.623,
  y1: 1.165,
  y2: 55.159,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a1a1a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1a1a1a",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__b",
  x1: 67.398,
  x2: 67.398,
  y1: 1.165,
  y2: 55.159,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a1a1a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1a1a1a",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__c",
  x1: 79.395,
  x2: 79.395,
  y1: 1.165,
  y2: 19.135,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a1a1a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1a1a1a",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__d",
  x1: 163.427,
  x2: 163.427,
  y1: 0,
  y2: 56.191,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a1a1a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1a1a1a",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__e",
  x1: 215.434,
  x2: 215.434,
  y1: 1.165,
  y2: 55.159,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a1a1a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1a1a1a",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__f",
  x1: 114.924,
  x2: 114.924,
  y1: 1.165,
  y2: 55.159,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a1a1a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1a1a1a",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__g",
  x1: 19.863,
  x2: 19.863,
  y1: 1.165,
  y2: 55.159,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a1a1a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1a1a1a",
  stopOpacity: 0
})))));
export default SvgLogo;